import { DURATION_SPAN_MONTHLY, DURATION_SPAN_QUARTERLY, DURATION_SPAN_YEARLY, DURATION_SPAN_HALFYEARLY, DURATION_SPAN_BIENNIAL,DURATION_SPAN_DAY, DURATION_SPAN_YEARLY_ZUORA } from "./product";

let durationLabelKey = {};
durationLabelKey[DURATION_SPAN_DAY] = 'day';
durationLabelKey[DURATION_SPAN_MONTHLY] = 'month';
durationLabelKey[DURATION_SPAN_QUARTERLY] = 'quarter';
durationLabelKey[DURATION_SPAN_HALFYEARLY] = 'semester';
durationLabelKey[DURATION_SPAN_YEARLY] = 'year';
durationLabelKey[DURATION_SPAN_YEARLY_ZUORA] = 'year';
durationLabelKey[DURATION_SPAN_BIENNIAL] = 'biennium';

export const DURATION_LABEL_KEYS = durationLabelKey;

export enum loginAvailableViews { LOGIN = 'login', REGISTER = 'register' }

export const ADD_TO_WISHLIST_ICON_ANIMATION = 'animate-pulse-fast';

export const LOGO = '/resources/solepro/images/logo-positive.svg'